import React, { useEffect } from 'react';

import Router from 'components/Router/Router';
import { AuthContextProvider } from 'utils/contexts/auth-context';
import { ThemeModeProvider } from 'utils/contexts/theme-mode.context';
import { Auth0Provider } from '@auth0/auth0-react';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DNS,
  environment: process.env.REACT_APP_SENTRY_ENV,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      ),
    }),
    new Sentry.Replay(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    process.env.REACT_APP_SENTRY_TRACE_PROPAGATION_URL || '',
    /^zoom-app(-staging)?\.sorenson(dev|prod|qa)\.(biz|com)$/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

declare let pendo: any;

function App() {
  useEffect(() => {
    if (!pendo) return;
    pendo.initialize({
      visitor: {
        id: 'VISITOR-UNIQUE-ID',
      },
    });
  }, []);

  return (
    <Auth0Provider
      domain={`${process.env.REACT_APP_DOMAIN}`}
      clientId={`${process.env.REACT_APP_CLIENT_ID}`}
      redirectUri={`${window.location.origin}/proxy/zoomapp/`}
      audience={process.env.REACT_APP_AUDIENCE}
    >
      <AuthContextProvider>
        <ThemeModeProvider>
          <Router />
        </ThemeModeProvider>
      </AuthContextProvider>
    </Auth0Provider>
  );
}

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_ENV_ID || '',
})(App);
